import React from 'react';
import parse from 'html-react-parser';
import { getMaxNumber } from '../globalUtils';
import { parseMarginPadding, parseItemResult } from '../controlUtils';
import { darkenHex } from "../colorUtils";

export function displayTableUtil(obj, entryPoint){

    const content = JSON.parse(obj.Content);
    const title = parse(content.Title);
    const theme = content.Theme;
    const size = content.Size;
    const data = content.Data;
    const tableData = getTableData(data);
    const marginPadding = content.MarginPadding;
    
    const mp = parseMarginPadding(marginPadding);

    const colors = theme.split("-");
    const bgColor = colors[0];
    const txtColor = colors[1];
    const extra1 = colors[2];
    const extra2 = colors[3];
    const extra3 = colors[4];

    let titleSz = 0; let textSz = 0; let zoom = 0;
    if(size == "small"){ titleSz=20; textSz=16 }
    else if(size == "medium"){ titleSz=24; textSz=18 }
    else if(size == "large"){ titleSz=34; textSz=24 }

    if(entryPoint == "presentation" && obj.Presentation != ""){
        const ptn = JSON.parse(obj.Presentation);
        if(ptn.TitleSize != "") { titleSz = parseInt(ptn.TitleSize) }
        if(ptn.TextSize != "") { textSz = parseInt(ptn.TextSize) }
        if(ptn.Zoom != "") { zoom = parseInt(ptn.Zoom) }
    }
    
    const styles = {
        container:{
            flex: 1,
            zoom: `${zoom}%`,
            marginTop: mp.marginTop,
            marginRight: mp.marginRight,
            marginBottom: mp.marginBottom,
            marginLeft: mp.marginLeft,
        },
        title: {
            fontSize: titleSz,
            fontWeight: 600
        },
        table: {
            overflowX: 'scroll'
        },
        colH: {
            background: (bgColor == "#fff")? "#8e8e8e": darkenHex(bgColor, 50),
            color: "#fff",
            minWidth: 50,
            paddingTop: mp.paddingTop,
            paddingRight: mp.paddingRight,
            paddingBottom: mp.paddingBottom,
            paddingLeft: mp.paddingLeft,
            fontSize: textSz
        },
        col: {
            background: bgColor,
            color: txtColor,
            minWidth: 50,
            paddingTop: mp.paddingTop,
            paddingRight: mp.paddingRight,
            paddingBottom: mp.paddingBottom,
            paddingLeft: mp.paddingLeft,
            fontSize: textSz
        }
    }

    return (
        <div style={styles.container} className={"item-table"}>

            {(title != "") &&
                <h4 style={styles.title} className = 'element-title'>{parse(title)}</h4>
            }

            <div className={"hide-scroll-bar"} style={styles.table} >
                <table className='table table-bordered table-striped table-sm table-hover'>
                    <thead>
                        {displayRow(obj, entryPoint, tableData[0], 0, styles.colH, 0)}
                    </thead>
                    <tbody>
                        {tableData.map((row, rowIndex) => (
                            <>{(rowIndex > 0) && 
                                displayRow(obj, entryPoint, row, rowIndex, styles.col, (rowIndex + 1) * 0.2)
                            }</>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export function getTableData(data){
    
    const rowIndexes = data.map(x => x.RowIndex);
    const colIndexes = data.map(x => x.ColIndex);
    let tableData = [];
    
    //Add 1 because of 0 index
    const maxRow = getMaxNumber(rowIndexes) + 1;
    const maxCol = getMaxNumber(colIndexes) + 1;
    
    //Generate cell data and assign matching values based on max and min rows and cols
    for(let i=0; i<maxRow; ++i){
        let row = [];
        for(let j=0; j<maxCol; ++j){
            const rec = data.find(x=>{return x.RowIndex==i && x.ColIndex==j});
            if(rec != null){
                row.push({val: rec.CellValue});
            }else{
                row.push({val: "&nbsp;"});
            }
        }
        tableData.push(row);
    }

    return tableData;
}

function displayRow(obj, entryPoint, row, rowIndex, style, duratn){
    return (
        <tr key={rowIndex} >
            {row.map((cell, colIndex) => (
                <>
                    {(rowIndex == 0)?
                        <th key={colIndex} style={style}> 
                            {parseItemResult(parse(cell.val), obj, entryPoint, duratn)}
                        </th>:
                        <td key={colIndex} style={style}> 
                            {parseItemResult(parse(cell.val), obj, entryPoint, duratn)}
                        </td>
                    }
                </>
            ))}
        </tr>
    )
}

export const tableInit = [
    [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, ""],
    [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, ""],
    [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, ""],
    [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, ""],
    [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, ""],
    [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, ""],
    [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, ""],
    [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, ""],
    [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, ""],
    [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, ""],
    [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, ""],
    [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, ""],
    [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, ""],
    [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, ""],
    [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, ""],
    [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, ""],
    [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, ""],
    [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, ""],
    [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, ""],
    [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, ""],
    [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, ""],
    [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, ""],
    [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, ""],
    [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, ""],
    [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, ""],
    [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, ""],
    [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, ""],
    [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, ""],
    [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, ""],
    [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, ""],
    [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, ""],
    [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, ""],
    [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, ""],
    [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, ""],
    [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, ""],
    [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, ""],
    [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, ""],
    [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, ""],
    [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, ""],
    [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, ""],
    [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, ""],
    [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, ""],
    [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, ""],
    [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, ""],
    [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, ""],
    [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, ""],
    [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, ""],
    [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, ""],
    [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, ""],
    [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, ""],
    [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, ""]
]